import { POST_SALES_APARTMENT } from "./type";

const initalState = {
  postApartData: [],
};

const appartmentPostLeadReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case POST_SALES_APARTMENT:
      return {
        ...state,
        postApartData: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default appartmentPostLeadReducer;
